import { getSettingsRootUrl } from './getSettingsRootUrl';
export function getAllowDenyListSettingsUrl() {
  return `${getSettingsRootUrl()}/allow-and-deny-list`;
}